import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { SearchSummaryPropertiesType } from "@website/widget/search-summary-group/types";
import { FC } from "react";
export const SearchSummaryGroup: FC<SearchSummaryPropertiesType> = properties => {
  const $ = _c(6);
  const {
    title,
    onClick
  } = properties;
  let t0;
  if ($[0] !== title) {
    t0 = <div className="flex w-full min-w-0 shrink max-md:flex-col"><h1 className="md:border-l-outline-thin max-md:text-body-2 truncate text-right max-md:mt-1.5 md:my-2 md:border-l md:px-4">{title}</h1></div>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="md:bg-primary text-on-surface-medium-emphasis md:text-on-color-high-emphasis flex size-6 shrink-0 items-center justify-center rounded-full text-2xl md:size-9"><MaterialIcon name="search" /></div>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onClick || $[4] !== t0) {
    t2 = <button className="bg-dim-background border-outline-thin text-on-surface-high-emphasis text-subtitle-2 flex w-max max-w-[1200px] items-center gap-2 rounded-full border px-4 max-md:w-full max-md:py-3 md:gap-0 md:px-0 md:pl-[2px]" onClick={onClick} type="button">{t0}{t1}</button>;
    $[3] = onClick;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};